import React from 'react';
import './App.css';

function App() {
  return (
    <div className="container">
      <h1 id="loadingTitle">Loading<span className="dots"></span></h1>
      <p className="subtitle">#1 LOADING CAT ON <span className="solana">SOLANA</span></p>
      <img src="loading.gif" alt="Loading Cat" className="loading-cat" />
      <div className="buttons">
        <a href="https://raydium.io/swap/?inputMint=sol&outputMint=CqmUxzusnbJM8KBJ6cwfVLNwjB66ZfmSRJGxMyBApump&referrer=GRZpBNeGMy9BN3Ry5dGf2YNzZuMLfdAydeAskdYDnHGn" target="_blank" className="button">
          <img src="ray.png" alt="Ray Icon" className="button-icon" /> Buy Loading Cat
        </a>
        <a href="https://dexscreener.com/solana/3bbmmhbskeg825z4kuss7vyyw7ieywfvknk8hky6kea7" target="_blank" className="button">
          <img src="dex.png" alt="Dex Icon" className="button-icon" /> View Chart
        </a>
      </div>
    </div>
  );
}

export default App;
